import React from 'react';
import { TableFilter } from 'components/UI/Table';
import { GroupsEnum } from 'types/users';

/**
 * Хук для инициализации фильтра с датами в зависимости от прав доступа пользователя
 * @param user - текущий пользователь
 * @returns объект с фильтром и функцией setFilter
 */
export function useFilterInitialization(user: any) {
	const retailDaysLimit = parseInt(process.env.REACT_APP_RETAIL_DAYS_LIMIT || '3', 10);
	const hasFullAccess = user?.groups?.includes(GroupsEnum.FULL_ACCESS);

	const [filter, setFilter] = React.useState<TableFilter>(() => {
		const toDate = new Date();
		const fromDate = new Date();

		// С 1-го числа месяца для пользователей с полным доступом
		if (hasFullAccess) {
			fromDate.setDate(1);
		} else {
			// Последние 3 дня для остальных пользователей
			fromDate.setDate(fromDate.getDate() - retailDaysLimit);
		}

		return new TableFilter({ fromDate, toDate });
	});

	return { filter, setFilter };
}
